export const initBlockData = {
  title: "Latest Stories",
};

export const initEmptyBlockData = {
  title: "",
};
